module.exports = __webpack_public_path__ + "img/cleader3.573b2d5d.png";